import React from 'react'
import { connect } from 'react-redux'
import { resetProgress } from '../../store/actions'
import styles from './DevMode.module.css'

class DevMode extends React.Component {
  handleClick = e => {
    if(!window.confirm('Weet je zeker dat je de voortgang van de e-learning wilt wissen?')) return

    const name = window.prompt('Vul een naam in:', this.props.account.user.name)
    if(!name) return

    const role = window.prompt('Vul een rol in (student|coach):', this.props.account.user.role)
    if(!role) return

    const user = { id: 1, name, role }

    this.props.resetProgress({ user })

    window.location.reload()
  }

  render() {
    return (
      <div className={styles.base}>
        <div className={styles.button} onClick={this.handleClick}>R</div>
      </div>
    )
  }
}

export default connect(
  (state) => ({
    account: state.account,
  }),
  (dispatch) => ({
    resetProgress: data => dispatch(resetProgress(data)),
  }),
)(DevMode)
